import { render, staticRenderFns } from "./genealogy.vue?vue&type=template&id=d99188cc&scoped=true"
import script from "./genealogy.vue?vue&type=script&lang=js"
export * from "./genealogy.vue?vue&type=script&lang=js"
import style0 from "./genealogy.vue?vue&type=style&index=0&id=d99188cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99188cc",
  null
  
)

export default component.exports